export default __webpack_public_path__ + "static/media/ProductSans-Black.48e85aaf.woff2";